import { Navigate, Outlet } from "react-router-dom";

const AdminPublicRoute = () => {
  const token = sessionStorage.getItem("accessToken");
  return !token ? <Outlet /> : <Navigate to="/dashboard" />;
};

export default AdminPublicRoute;